import React, { FunctionComponent } from 'react'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'
import { Trans } from '@lingui/macro'
import { has } from 'lodash'

import { useMatchMedia } from 'hooks'
import UserReview, { UserReviewQueryType } from 'components/userReview'
import { breakpoints } from 'components/grid'
import Carousel from 'components/carousel'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

import { title, carousel } from './index.module.scss'

export type RTFContentfulUserReviewGroupGraphQLResult = {
  __typename: EF.RTFBlockTypename.ContentfulUserReviewGroup
} & UserReviewQueryType &
  ContentfulRichTextGatsbyReference

export interface ContentfulUserReviewGroupBlockProps
  extends RTFBlockComponentProps {
  reviews: UserReviewQueryType[]
}

const ContentfulUserReviewGroupBlock: FunctionComponent<ContentfulUserReviewGroupBlockProps> = ({
  reviews,
}) => {
  const { matches: isLarge } = useMatchMedia(`(min-width: ${breakpoints.lg}px)`)

  return (
    <div>
      <div className={title}>
        <Trans>User Reviews</Trans>
      </div>
      <Carousel
        className={carousel}
        gap={isLarge ? 80 : 20}
        defaultIndex={isLarge ? 1 : 0}
        keyPrefix="user-review"
        showDots
      >
        {reviews.map(
          ({ name, photo, review: { review }, isPro, rating }, idx) => (
            <UserReview
              key={`user-review-${idx}`}
              name={name}
              photo={photo.fields.asset}
              review={review}
              isPro={isPro}
              rating={rating}
            />
          )
        )}
      </Carousel>
    </div>
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulUserReviewGroupBlock,
  isValid: ({ reviews }) =>
    Array.isArray(reviews) &&
    reviews.every(
      (review) =>
        !!review &&
        has(review, 'review.review') &&
        has(review, 'photo.fields.asset.fixed')
    ),
}

export default componentExport
